module.exports = __webpack_public_path__ + "static/media/2016_conf_Insigths_25_Years_Productizing.0db28666.png";